import { AddInsightToCollectionsButton, CreateInsightDataFn, Proposition } from '@ecosystem/newron-client-collections';
import { FC } from 'react';
import { getCollectionsAmplitudeTrackingTags } from '@utils/collectionUtils/CollectionUtils';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { CategoryLeaderboardDoubleBarChartInsight } from '@components/collections/category-leaderboard-double-bar-chart/Model';
import { PerformanceAnalysisLineChartInsight } from '@components/collections/performance-analysis-line-chart/Model';
import classnames from 'classnames';
import { PerformanceAnalysisStackedBarChartInsight } from '@components/collections/performance-analysis-stacked-bar-chart/Model';
import { ExploreView, ExploreViewTypeCollectionMapping } from '@utils/exploreUtils/ExploreType';
import { TrendStackBarChartInsight } from '@components/collections/explore-trends-stacked-bar-chart/Model';
import { CreateViewStateFn } from '@ecosystem/newron-client-lib';
import { ProductsMarketRetailerLineChartInsightParams } from '@data-visualization/products-market-line-chart/Types';

interface ExploreCollectionButtonProps {
  isDisabled: boolean;
  createInsightDataFn: CreateInsightDataFn<
    | CategoryLeaderboardDoubleBarChartInsight
    | PerformanceAnalysisLineChartInsight
    | PerformanceAnalysisStackedBarChartInsight
    | TrendStackBarChartInsight
  >;
  exploreViewForCollections: ExploreView;
  createViewStateFn?: CreateViewStateFn<any>;
}

const ExploreCollectionButton: FC<ExploreCollectionButtonProps> = ({
  isDisabled,
  createInsightDataFn,
  exploreViewForCollections,
  createViewStateFn,
}) => {
  const pagesConfig = usePageConfig();
  const buttonClassName = classnames('flex items-center gap-4 mx-2', {
    'opacity-100': !isDisabled,
    'opacity-25 pointer-events-none': isDisabled,
  });

  if (exploreViewForCollections === 'Leaderboard Table') {
    return null;
  }

  return (
    <span className={buttonClassName} data-testid="explore-collection-btn">
      <AddInsightToCollectionsButton<
        | CategoryLeaderboardDoubleBarChartInsight
        | PerformanceAnalysisLineChartInsight
        | PerformanceAnalysisStackedBarChartInsight
        | TrendStackBarChartInsight
        | ProductsMarketRetailerLineChartInsightParams
      >
        type={ExploreViewTypeCollectionMapping[exploreViewForCollections]}
        proposition={Proposition.Retail}
        createInsightDataFn={createInsightDataFn}
        selectDataType={true}
        defaultDataType={'live'}
        getTrackingTags={getCollectionsAmplitudeTrackingTags(pagesConfig)}
        createViewStateFn={createViewStateFn}
      />
    </span>
  );
};

export default ExploreCollectionButton;
